import { render, staticRenderFns } from "./Convert.vue?vue&type=template&id=06c0819e&scoped=true"
import script from "./Convert.vue?vue&type=script&lang=js"
export * from "./Convert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0819e",
  null
  
)

export default component.exports